if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      async handleUpsell() {
        let state = ''
        const limit = 3
        const _self = this
        const cart = await fetch('/cart.js')
        const cartRes = await cart.json()
        let cartHasBottle = false
        let cartBottleQty = 0
        let cartBracelet = false
        let cartBraceletQty = 0
        cartRes.items.forEach(function(item){
          if (item.product_title === 'FTL Insulated Water Bottle') {
            cartHasBottle = true
            cartBottleQty = cartBottleQty + item.quantity
            console.log(item.quantity)
            return
          }
          if (item.product_title === 'FTL Custom Fitness Bracelets') {
            cartBracelet = true
            cartBraceletQty = cartBraceletQty + item.quantity
            return
          }
        })
        if (cartRes.total_price >= 10000 && cartRes.total_price < 15000 && !cartHasBottle) {
          // Bottle Upsell
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              'items': [{
              'id': 50085657739555,
              'quantity': 1
              }],
            sections: _self.cart.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
            })
          })
          const data = await res.json()
          state = data
        }
        if (cartRes.total_price >= 15000 && cartRes.total_price < 18999 && !cartBracelet) {
          // Bracelets
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              'items': [{
              'id': 49843267535139,
              'quantity': 1
              }],
            sections: _self.cart.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
            })
          })
          const data = await res.json()
          state = data
        }
        if (cartRes.total_price >= 18999) {
          const finalBraceletQty = (limit - cartBraceletQty)
          const finalBottleQty = (limit - cartBottleQty)
          const items = []
          if (finalBraceletQty > 0) {
            items.push({
              'id': 49843267535139,
              'quantity': finalBraceletQty
            })
          }
          if (finalBottleQty > 0) {
            items.push({
              'id': 50085657739555,
              'quantity': finalBraceletQty
            })
          }
          if (items.length <= 0) return state
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              'items': [...items],
            sections: _self.cart.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
            })
          })
          const data = await res.json()
          state = data
        }
        return state
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(async () => {
                    try {
                      const state = await this.handleUpsell();
                      const newState = state === '' || typeof state === 'undefined' ? response : state
                      this.cart.renderContents(newState);
                    } catch {
                       this.cart.renderContents(response); 
                    }
                    // this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              try {
                const state = await this.handleUpsell();
                const newState = state === '' || typeof state === 'undefined' ? response : state
                this.cart.renderContents(newState);
              } catch {
                 this.cart.renderContents(response); 
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
